<form #FileForm="ngForm" class="file-manager">
    <div class="row file-manager-fields" *ngIf="!readOnly">
        <!--Handle countries market distributors-->
        <div class="form-group col-md-6" *ngIf="showCountriesMarketDistributors">
            <label class="form-label" for="CountrySelect">{{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.COUNTRY_OF_ASSOCIATION'
                | translate}}</label>
            <ng-select [items]="countriesMarketDistributorsList" [multiple]="true" [closeOnSelect]="false"
                [searchable]="true" bindLabel="{{isEnglish ? 'nameEnglish': 'name'}}"
                placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.COUNTRY_OF_ASSOCIATION' | translate}}"
                [readonly]="false" [(ngModel)]="countriesMarketDistributors" #CountrySelectRef="ngModel"
                name="CountrySelect" id="CountrySelect" [class.error]="!CountrySelectRef.valid && FileForm.submitted"
                required>
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label"> {{ item.name }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </ng-template>
            </ng-select>
        </div>
        <!-- Handle unique fileType's -->
        <div class="form-group col-md-6" *ngIf="!isMultipleFileType">
            <label class="form-label" for="filetype">{{'BRAND.WIZARD.FILES.FILE_TYPE' | translate}}</label>
            <ng-select [items]="fileTypeList" bindLabel="{{isEnglish ? 'nameEnglish' : 'name'}}"
                [loading]="fileTypeLoading"
                placeholder="{{'COMMON.PLACEHOLDER.SELECT'|translate}} {{'BRAND.WIZARD.FILES.FILE_TYPE' | translate}}"
                [(ngModel)]="fileType" #selectFileTypeRef="ngModel" required name="filetype" id="filetype"
                [readonly]="false" [class.error]="!selectFileTypeRef.valid && FileForm.submitted">
            </ng-select>
        </div>
        <!-- Handle filetype's multi selections -->
        <div class="form-group col-md-6" *ngIf="isMultipleFileType">
            <label class="form-label" for="multifiletype">{{'INGREDIENTS.WIZARD.FILES.FILE_TYPE' | translate}}</label>
            <ng-select [items]="multiFileTypeList" bindLabel="{{isEnglish ? 'nameEnglish' : 'name'}}"
                [loading]="multiFileTypeLoading" [multiple]="true"
                placeholder="{{'COMMON.PLACEHOLDER.SELECT'|translate}} {{'INGREDIENTS.WIZARD.FILES.FILE_TYPE' | translate}}"
                [(ngModel)]="multiFileType" #multiFileTypeRef="ngModel" required name="multifiletype" id="multifiletype"
                [readonly]="false" [class.error]="!multiFileTypeRef.valid && FileForm.submitted">
            </ng-select>
        </div>
        <!-- Date field -->
        <div class="form-group col-md-6" *ngIf="addDateField">
            <label class="form-label" for="dueDate">{{'INGREDIENTS.WIZARD.FILES.DUE_DATE' | translate}}</label>
            <div class="input-group">
                <input class="form-control" placeholder="dd/mm/yyyy" name="dueDate"
                    id="dueDate" [(ngModel)]="dueDate" ngbDatepicker #endDP="ngbDatepicker" #dueDateRef="ngModel"
                    [disabled]="!FileForm.controls['multifiletype']?.value"
                    [class.error]="!dueDateRef.valid && FileForm.submitted" />
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary file-manager-calendar" (click)="endDP.toggle()"
                        type="button" [attr.aria-label]="'INGREDIENTS.WIZARD.FILES.DUE_DATE' | translate" rippleEffect>
                        <lucide-icon name="calendar" [size]="16"></lucide-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- Suppliers field -->
        <div class="form-group col-md-6" *ngIf="showSuppliersList">
            <label class="form-label" for="fileSuppliers">{{'INGREDIENTS.WIZARD.SUPPLIERS.SINGULAR_SUPPLIER' | translate}}</label>
            <ng-select [items]="suppliersList" [multiple]="true" [closeOnSelect]="false" [searchable]="true"
                bindLabel="name"
                placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{'INGREDIENTS.WIZARD.SUPPLIERS.SINGULAR_SUPPLIER' | translate}}"
                [(ngModel)]="fileSuppliers" #fileSuppliersRef="ngModel"
                name="fileSuppliers" id="fileSuppliers">
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">{{ item.name }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </ng-template>
            </ng-select>
        </div>
        <!--Comment ES field-->
        <div class="col-md-6 form-group" *ngIf="!readOnly && showCommentField">
            <label class="form-label" for="filecomment">{{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT'|
                translate}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="name_es"><i class="flag-icon flag-icon-es"></i> </span>
                </div>
                <textarea [(ngModel)]="fileComment" #fileCommentRef="ngModel" class="form-control" id="filecomment"
                    name="filecomment" rows="2"
                    placeholder="{{'COMMON.PLACEHOLDER.INPUT' | translate}} {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT' | translate}}"
                    [readonly]="false" maxlength="250" [class.error]="!fileCommentRef.valid && FileForm.submitted"
                    (focusout)="translateFileComment($event)"></textarea>
            </div>
            <span *ngIf="FileForm.submitted && fileCommentRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="fileCommentRef.errors.required">
                    {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT' |
                    translate}} {{'COMMON.VALIDATIONS.REQUIRED' | translate}}
                </small>
            </span>
        </div>
        <!--Comment En field-->
        <div class="col-md-6 form-group" *ngIf="!readOnly && showCommentField">
            <label class="form-label" for="filecommentEnglish">{{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT'|
                translate}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="name_en"><i class="flag-icon flag-icon-us"></i> </span>
                </div>
                <textarea [(ngModel)]="fileCommentEnglish" #fileCommentEnglishRef="ngModel" class="form-control"
                    id="filecommentEnglish" name="filecommentEnglish" rows="2"
                    placeholder="{{'COMMON.PLACEHOLDER.INPUT' | translate}} {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT' | translate}}"
                    [readonly]="readOnlyStatus" maxlength="250"
                    [class.error]="!fileCommentEnglishRef.valid && FileForm.submitted"></textarea>
            </div>
            <span *ngIf="FileForm.submitted && fileCommentEnglishRef.invalid" class="invalid-form">
                <small class="form-text text-danger" *ngIf="fileCommentEnglishRef.errors.required">
                    {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.FILE_COMMENT' |
                    translate}} {{'COMMON.VALIDATIONS.REQUIRED' | translate}}
                </small>
            </span>
        </div>
        <!--Language field-->
        <div class="form-group col-md-6" *ngIf="fileType?.nameEnglish == 'Tag'">
            <label class="form-label" for="languageselect">{{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.LABEL_LANGUAGE'
                | translate}}</label>
            <ng-select [items]="languagesList" [multiple]="true" [closeOnSelect]="false" [searchable]="true"
                bindLabel="{{isEnglish ? 'nameEnglish' : 'name'}}"
                placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.LABEL_LANGUAGE' | translate}}"
                [loading]="languageLoading" [(ngModel)]="languages" #MultiSelectionLanguageRef="ngModel"
                name="languageselect" id="languageselect" [readonly]="false"
                [class.error]="!MultiSelectionLanguageRef.valid && FileForm.submitted" required>
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label"> {{ item.name }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </ng-template>
            </ng-select>
        </div>
        <!--File field-->
        <div
            [ngClass]="(addDateField || (showCountriesMarketDistributors && fileType?.nameEnglish != 'Tag')) && !showSuppliersList ? 'col-md-12' : 'col-md-6'">
            <fieldset class="form-group">
                <label class="form-label" for="file-upload-single">{{'BRAND.WIZARD.FILES.FILE' | translate}}</label>
                <div class="custom-file">
                    <input type="file" class="custom-file-input" type="file" ng2FileSelect [uploader]="uploader"
                        id="file-upload-single" #fileInputRef
                        [disabled]="(!showCountriesMarketDistributors && !isMultipleFileType && !FileForm.controls['filetype']?.value) || (isMultipleFileType && ((multiFileType.length == 0) || !dueDate))
                                    || (showCountriesMarketDistributors && ((countriesMarketDistributors.length == 0 || !FileForm.controls['filetype']?.value) || (fileType?.nameEnglish == 'Tag' && languages.length == 0) ))" />
                    <label class="custom-file-label">{{'COMMON.PLACEHOLDER.SELECT'|translate}}
                        {{'BRAND.WIZARD.FILES.FILE' | translate}}</label>
                </div>
            </fieldset>
        </div>
    </div>
    <div class="row" *ngIf="!showsThumbsView">
        <div class="col-md-12">
            <ngx-datatable #datatableRef [rows]="arrFileDisplay" [rowHeight]="'auto'" class="bootstrap core-bootstrap table-panel" [limit]="tablePageSize"
                [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="50" [scrollbarH]="true"
                [groupRowsBy]="showSuppliersList ? 'supplierGroupKey' : null">
                <ngx-datatable-group-header *ngIf="showSuppliersList" [rowHeight]="40">
                    <ng-template let-group="group" let-expanded="expanded" ngx-datatable-group-header-template>
                        <div class="d-flex align-items-center pl-1" style="font-size: 0.9rem;">
                            <a href="javascript:void(0)"
                               [class.datatable-icon-right]="!expanded"
                               [class.datatable-icon-down]="expanded"
                               class="mr-2"
                               [title]="'COMMON.ACTIONS.TOGGLE_GROUP' | translate"
                               (click)="datatableRef.groupHeader.toggleExpandGroup(group)">
                            </a>
                            <strong>{{ group.value[0]?.supplierGroupName }}</strong>
                        </div>
                    </ng-template>
                </ngx-datatable-group-header>
                <ngx-datatable-column name="{{'BRAND.WIZARD.FILES.NAME' | translate}}"
                    [width]="isMultipleFileType ? 300 : 350" prop="documentName" [sortable]="true">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <span class="table-panel-title" *ngIf="!row.documentUrl">{{ row?.documentName | slice:0:35 }}...</span>
                        <a class="text-primary table-panel-title cursor-pointer" [ngbTooltip]="'COMMON.ACTIONS.VIEW' | translate" container="body" placement="bottom" *ngIf="row.documentUrl"
                            (click)="openFileViewer(row)">{{row?.documentName | slice:0:35}}...</a>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'PRODUCTS.WIZARD.PRESENTATIONS.FILES.COUNTRY' | translate}}" [width]="400"
                    [sortable]="true" prop="country" *ngIf="showCountriesMarketDistributors">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row?.country}}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'BRAND.WIZARD.FILES.TYPE' | translate}}" [width]="220" [sortable]="true"
                    *ngIf="!isMultipleFileType" prop="{{isEnglish ? 'nameEnglish' : 'name'}}">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        {{isEnglish ? row?.fileType.nameEnglish : row?.fileType.name}}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'INGREDIENTS.WIZARD.FILES.TYPE' | translate}}" [width]="200"
                    [sortable]="true" prop="{{isEnglish ? 'nameEnglish' : 'name'}}" *ngIf="isMultipleFileType">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <ng-container *ngIf="editingRow !== (row._source || row) || editingGroupKey !== row.supplierGroupKey">
                            <span *ngFor="let ft of row.fileTypes; let i = index" class="text-wrap text-break">
                                {{isEnglish ? ft.fileType.nameEnglish : ft.fileType.name}}
                                <hr *ngIf="row.fileTypes.length - 1 !== i" />
                            </span>
                        </ng-container>
                        <ng-container *ngIf="editingRow === (row._source || row) && editingGroupKey === row.supplierGroupKey">
                            <ng-select [items]="multiFileTypeList" bindLabel="{{isEnglish ? 'nameEnglish' : 'name'}}"
                                [loading]="multipeFileTypeLoading" [multiple]="true" [closeOnSelect]="false" appendTo="body"
                                placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{'INGREDIENTS.WIZARD.FILES.FILE_TYPE' | translate}}"
                                [(ngModel)]="editingFileTypes" [ngModelOptions]="{standalone: true}"
                                class="file-manager-edit-select">
                            </ng-select>
                        </ng-container>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="350" [sortable]="true" prop="comment" *ngIf="showCommentField">

                    <ng-template ngx-datatable-header-template>
                        <i class="flag-icon flag-icon-es mr-1"></i>
                        {{'FORMULAS.WIZARD.DOCUMENTS.COMMENT' | translate}}
                    </ng-template>

                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a (click)="showComment(row.comment)" class="text-primary" placement="bottom"
                            ngbTooltip="{{ 'COMMON.ACTIONS.SHOW' | translate }}" container="body">
                            {{row?.comment| slice:0:100 }}...
                        </a>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="350" [sortable]="true" prop="commentEnglish" *ngIf="showCommentField">

                    <ng-template ngx-datatable-header-template>
                        <i class="flag-icon flag-icon-us mr-1"></i>
                        {{'FORMULAS.WIZARD.DOCUMENTS.COMMENT' | translate}}
                    </ng-template>

                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <a (click)="showComment(row.commentEnglish)" class="text-primary" placement="bottom"
                            ngbTooltip="{{ 'COMMON.ACTIONS.SHOW' | translate }}" container="body">
                            {{row?.commentEnglish| slice:0:100 }}...
                        </a>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'INGREDIENTS.WIZARD.FILES.DUE_DATE' | translate}}" [width]="180"
                    [sortable]="true" prop="dueDate" *ngIf="isMultipleFileType">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <ng-container *ngIf="editingRow !== (row._source || row) || editingGroupKey !== row.supplierGroupKey">
                            {{row.dueDate | date: 'dd-MM-yyyy'}}
                        </ng-container>
                        <ng-container *ngIf="editingRow === (row._source || row) && editingGroupKey === row.supplierGroupKey">
                            <div class="input-group file-manager-edit-datepicker">
                                <input class="form-control" placeholder="dd/mm/yyyy"
                                    [(ngModel)]="editingDueDate" [ngModelOptions]="{standalone: true}"
                                    ngbDatepicker #editDP="ngbDatepicker" [container]="'body'" />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary file-manager-calendar"
                                        (click)="editDP.toggle()" type="button"
                                        title="{{'INGREDIENTS.WIZARD.FILES.DUE_DATE' | translate}}"
                                        [attr.aria-label]="'INGREDIENTS.WIZARD.FILES.DUE_DATE' | translate">
                                        <lucide-icon name="calendar" [size]="16"></lucide-icon>
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'INGREDIENTS.WIZARD.SUPPLIERS.SINGULAR_SUPPLIER' | translate}}" [width]="220"
                    [sortable]="false" *ngIf="showSuppliersList">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <ng-container *ngIf="editingRow !== (row._source || row) || editingGroupKey !== row.supplierGroupKey">
                            <span *ngFor="let s of row.suppliers"
                                class="badge badge-pill badge-light-primary mr-25 mb-25">
                                {{ s.name }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="editingRow === (row._source || row) && editingGroupKey === row.supplierGroupKey">
                            <ng-select [items]="suppliersList" bindLabel="name"
                                [multiple]="true" [closeOnSelect]="false"
                                [(ngModel)]="editingSuppliers" [ngModelOptions]="{standalone: true}"
                                placeholder="{{'COMMON.PLACEHOLDER.SELECT' | translate}} {{'INGREDIENTS.WIZARD.SUPPLIERS.SINGULAR_SUPPLIER' | translate}}"
                                appendTo="body" class="file-manager-edit-select">
                                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                    <span class="ng-value-label">{{ item.name }}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </ng-template>
                            </ng-select>
                        </ng-container>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'COMMON.ACTIONS.ACTIONS' | translate}}" [width]="90" [sortable]="false"
                    *ngIf="!readOnly">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                        <div class="table-panel-actions">
                            <ng-container *ngIf="editingRow !== (row._source || row) || editingGroupKey !== row.supplierGroupKey">
                                <button *ngIf="showEditButton" type="button"
                                    class="table-panel-action"
                                    (click)="startEdit(row)" container="body" placement="bottom"
                                    ngbTooltip="{{'COMMON.ACTIONS.EDIT' | translate}}"
                                    [attr.aria-label]="'COMMON.ACTIONS.EDIT' | translate">
                                    <lucide-icon name="square-pen" [size]="16"></lucide-icon>
                                </button>
                                <button type="button" class="table-panel-action table-panel-action--danger"
                                    (click)="deleteFile(row)" container="body" placement="bottom"
                                    ngbTooltip="{{'COMMON.ACTIONS.DELETE' | translate}}"
                                    [attr.aria-label]="'COMMON.ACTIONS.DELETE' | translate">
                                    <lucide-icon name="trash-2" [size]="16"></lucide-icon>
                                </button>
                            </ng-container>
                            <ng-container *ngIf="editingRow === (row._source || row) && editingGroupKey === row.supplierGroupKey">
                                <button type="button" class="table-panel-action"
                                    (click)="saveEdit()" container="body" placement="bottom"
                                    ngbTooltip="{{'COMMON.BUTTONS.SAVE' | translate}}"
                                    [attr.aria-label]="'COMMON.BUTTONS.SAVE' | translate">
                                    <lucide-icon name="save" [size]="16"></lucide-icon>
                                </button>
                                <button type="button" class="table-panel-action table-panel-action--muted"
                                    (click)="cancelEdit()" container="body" placement="bottom"
                                    ngbTooltip="{{'COMMON.BUTTONS.CANCEL' | translate}}"
                                    [attr.aria-label]="'COMMON.BUTTONS.CANCEL' | translate">
                                    <lucide-icon name="x" [size]="16"></lucide-icon>
                                </button>
                            </ng-container>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div class="file-manager-progress" *ngIf="!readOnly">
                <span class="form-label">{{'BRAND.WIZARD.FILES.LOADING_PROGRESS' | translate}}</span>
                <ngb-progressbar type="primary" [value]="uploader.progress">
                </ngb-progressbar>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="showsThumbsView">
        <ng-template ngFor let-fileItem [ngForOf]="arrCards">
            <div class="col-md-4 col-sm-6 col-12 kb-search-content">
                <div class="card">
                    <a class="embed-responsive embed-responsive-4by3">
                        <img *ngIf="fileItem.previewUrl" class="card-img-top embed-responsive-item"
                            [src]="fileItem.previewUrl" [alt]="fileItem.documentName" [title]="fileItem.documentName" />
                    </a>
                    <div class="card-body">
                        <h4 class="card-title">
                            <a class="blog-title-truncate text-body-heading">
                                {{ fileItem.documentName | slice:0:35 }}
                            </a>
                        </h4>
                        <!-- <div class="card-text blog-content-truncate text-primary" [innerHTML]="(isEnglish ? fileItem.commentEnglish : fileItem.comment) | slice:0:100 " (click)="showComment(row.comment)">
                        </div> -->
                        <a (click)="showComment(isEnglish ? fileItem.commentEnglish : fileItem.comment)" class="card-text blog-content-truncate text-primary" placement="bottom"
                            ngbTooltip="{{ 'COMMON.ACTIONS.SHOW' | translate }}" container="body" *ngIf="fileItem.comment || fileItem.commentEnglish">
                            {{(isEnglish ? fileItem.commentEnglish : fileItem.comment) | slice:0:100 }}...
                        </a>
                        <hr />
                        <div class="table-panel-actions justify-content-end">
                            <button type="button" class="table-panel-action"
                                placement="bottom" ngbTooltip="{{ 'COMMON.ACTIONS.VIEW' | translate }}"
                                [attr.aria-label]="'COMMON.ACTIONS.VIEW' | translate"
                                (click)="openFileViewer(fileItem)" *ngIf="fileItem.documentUrl">
                                <lucide-icon name="eye" [size]="16"></lucide-icon>
                            </button>
                            <button type="button" class="table-panel-action"
                                placement="bottom" ngbTooltip="{{ 'COMMON.ACTIONS.DOWNLOAD' | translate }}"
                                [attr.aria-label]="'COMMON.ACTIONS.DOWNLOAD' | translate"
                                (click)="downloadFile(fileItem)" *ngIf="fileItem.documentUrl">
                                <lucide-icon name="download" [size]="16"></lucide-icon>
                            </button>
                            <button type="button" class="table-panel-action table-panel-action--danger"
                                placement="bottom" ngbTooltip="{{ 'COMMON.ACTIONS.DELETE' | translate }}"
                                [attr.aria-label]="'COMMON.ACTIONS.DELETE' | translate"
                                (click)="deleteFile(fileItem)">
                                <lucide-icon name="trash-2" [size]="16"></lucide-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <div class="col-12">
          <ngb-pagination [collectionSize]="arrFile.length" (pageChange)="setCardsPage($event)"
            class="d-flex justify-content-center" [pageSize]="cardsPageSize" aria-label="Default pagination">
            <ng-template ngbPaginationPrevious><lucide-icon name="chevron-left" [size]="18"></lucide-icon></ng-template>
            <ng-template ngbPaginationNext><lucide-icon name="chevron-right" [size]="18"></lucide-icon></ng-template>
          </ngb-pagination>
        </div>
    </div>
    <!-- Step buttons-->
    <!-- <div class="d-flex justify-content-end" *ngIf="!isWizard">
        <button (click)="customUploadAll()" type="button" class="btn btn-primary btn-next"
            [disabled]="uploader.isUploading" *ngIf="!readOnly" rippleEffect>
            <span class="align-middle d-sm-inline-block d-none">{{'COMMON.ACTIONS.UPLOAD_ALL' | translate}}</span>
        </button>
    </div> -->
    <div class="file-manager-actions" *ngIf="isWizard">
        <button type="button" (click)="back()" class="btn btn-outline-primary file-manager-action" rippleEffect>
            <lucide-icon name="arrow-left" [size]="16"></lucide-icon>
            <span>{{'COMMON.BUTTONS.BACK' | translate}}</span>
        </button>
        <button (click)="onSubmit()" type="button" class="btn btn-primary file-manager-action" [disabled]="uploader.isUploading"
            *ngIf="typeProcess=='create'||typeProcess=='edit'" rippleEffect>
            <lucide-icon name="save" [size]="16"></lucide-icon>
            <span>{{'COMMON.BUTTONS.SAVE' | translate}}</span>
        </button>
    </div>
</form>
